// ** React Imports
import React, { useContext, useEffect } from 'react'
import { Outlet } from "react-router-dom"

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout"

// ** Menu Items Array
import navigation from "@src/navigation/vertical"

import { AuthContext } from "@context/AuthContext";

const VerticalLayout = (props) => {

    const { userDetail } = useContext(AuthContext)

    useEffect(
        () =>
        {
            if (Object.keys(userDetail).length > 0) {

                if (userDetail?.menus?.length == 0) {
                    navigation?.map((menus, idx) => {
                        if(menus.id == 'complaint') {
                            delete navigation[idx]
                        }
                    })
                }

                navigation?.map((navigate, idx) =>
                {
                    if (navigate?.id == 'complaint') {
                        var childrens = []

                        navigate?.children &&
                            userDetail?.menus?.map((menu) => {
                                var children = navigate?.children?.find(child => child?.id == menu?.id)
                                childrens.push(children)
                            })
                            navigate.children = childrens
                    }
                    if (navigate?.id == 'profile') {
                        var my_childrens = []

                        navigate?.children?.map((child) => {
                            if (child?.id == 'teacher-info') {
                                my_childrens.push(child)
                            }

                            if (child?.id == 'zuvlukh' && userDetail?.advice_teacher) {
                                my_childrens.push(child)
                            }
                        })

                        navigate.children = my_childrens
                    }

                    if (navigate?.id == 'part_time') {
                        if (Object.keys(userDetail).length > 0 && !userDetail?.is_part_teacher) {
                            delete navigation[idx]
                        }
                    }

                    if (navigate?.id == 'volume_header' || navigate?.id == 'volume') {
                        if (Object.keys(userDetail).length > 0 && !userDetail?.is_hba) {
                            delete navigation[idx]
                        }
                    }

                })

            }

        },
        [userDetail]
    )

    return (
        <Layout menuData={navigation} {...props}>
            <Outlet />
        </Layout>
    )
}

export default VerticalLayout
